import { useState } from 'react';
import { get, has } from 'lodash';

export function useWarehouses({
    query = async () => {},
    path = 'data.data',
    defaultFetching = true,
    formatData = (data) => data,
}) {
    const [state, setState] = useState({
        isFetching: defaultFetching,
        error: null,
        dictionary: null,
        success: null,
    });

    const fetch = async (props) => {
        setState((_state) => ({
            ..._state,
            isFetching: true,
            error: null,
            success: null,
        }));

        try {
            const result = await query(props);

            if (has(result, 'data.errors')) {
                throw new Error('Error occurs in graphql');
            }

            setState((_state) => ({
                ..._state,
                isFetching: false,
                error: null,
                dictionary: formatData(get(result, path, null)),
                success: result.status === 200,
                result,
            }));
        } catch (e) {
            setState((_state) => ({
                ..._state,
                isFetching: false,
                error: e.message,
                dictionary: null,
                success: false,
                result: null,
            }));
        }
    };

    const reset = () => {
        setState((_state) => ({
            ..._state,
            isFetching: false,
            error: null,
            dictionary: null,
            status: null,
        }));
    };

    return [{ ...state }, { fetch, reset }];
}
